export var SIDEBAR_WIDTH = '3.75rem';
